export default class Node {
  constructor (
    data
  ) {
    this.data = data
  }

  setIndex = (index) => {
    this.v1index = index
    this.v3Index = index * 3
    this.v4Index = index * 4
  }

  getPosition = (array) => {
    return [
      array[this.v3Index],
      array[this.v3Index + 1],
      array[this.v3Index + 2]
    ]
  }

  getColor = (array) => {
    return [
      array[this.v3Index],
      array[this.v3Index + 1],
      array[this.v3Index + 2]
    ]
  }

  getScale = (array) => {
    return array[this.v1index]
  }

  getOpacity = (array) => {
    return array[this.v1index]
  }

  writePosition = (value = [0, 0, 0], array, index = this.v3Index) => {
    array[index] = value[0]
    array[index + 1] = value[1]
    array[index + 2] = value[2]
  }

  writeColor = (value = [255, 0, 0], array) => {
    array[this.v3Index] = value[0]
    array[this.v3Index + 1] = value[1]
    array[this.v3Index + 2] = value[2]
  }

  writeScale = (value, array) => {
    array[this.v1index] = value
  }

  writeOpacity = (value, array) => {
    array[this.v1index] = value
  }

  writeFa2Mass = (value = 1, array) => {
    array[this.v1index] = value
  }

  getFa2Mass = (array) => {
    return array[this.v1index]
  }

  writeFa2Convergence = (value = 1, array) => {
    array[this.v1index] = value
  }

  getFa2Convergence = (array) => {
    return array[this.v1index]
  }

  writeFa2Size = (value = 1, array) => {
    array[this.v1index] = value
  }

  getFa2Size = (array) => {
    return array[this.v1index]
  }

  writeFa2Fixed = (value = 0, array) => {
    array[this.v1index] = value
  }

  getFa2Fixed = (array) => {
    return array[this.v1index]
  }
}
